export default __webpack_public_path__ + "dc6ac488236011cb77f483a99df8503d.png";